<template>
  <a-card
    style="border-radius: 8px; margin-bottom: 20px; padding: 0px 8px"
  >
    <h1
      style="
        font-size: 16px;
        font-weight: 800;
        color: #6b7280;
        margin-bottom: 16px !important;
      "
    >{{ title }}</h1>
    <div 
      v-for="field in fields" 
      :key="field.key"
      class="product-card-details"
    >
      <p class="product-card-header">{{ field.label }}</p>
      <p class="product-card-paragraph">
        {{ getFieldValue(field) }}
      </p>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'ProductDetailsCard',
  props: {
    title: {
      type: String,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      required: true,
      // Each field should have: { key: string, label: string, formatter: function (optional) }
      validator: (fields) => {
        return fields.every(field => 
          typeof field.key === 'string' && 
          typeof field.label === 'string'
        );
      }
    }
  },
  methods: {
    getFieldValue(field) {
      let value = this.product;
      const keys = field.key.split('.');
      for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
          value = value[k];
        } else {
          value = undefined; // Key not found or path invalid
          break;
        }
      }

      if (field.formatter) {
        return field.formatter(value, this.product);
      }
      return value || "N/A";
    }
  }
}
</script>

<style scoped>
.product-card-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 4px 0;
}

.product-card-header {
  color: #6b7280;
  font-size: 15px;
  font-weight: 400;
  flex: 1;
  margin-right: 16px;
}

.product-card-paragraph {
  color: #111827;
  font-weight: 500;
  font-size: 14px;
  text-align: right;
  min-width: 120px;
}
</style> 